import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaBoxOpen, FaProjectDiagram, FaChartLine, FaEnvelope } from 'react-icons/fa';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { to: '/', text: 'Home', icon: <FaHome /> },
    { to: '/features', text: 'Products', icon: <FaBoxOpen /> },
    { to: '/process', text: 'Why Us', icon: <FaProjectDiagram /> },
    { to: '/insights', text: 'Insights', icon: <FaChartLine /> },
    { to: '/contact', text: 'Contact', icon: <FaEnvelope /> }
  ];

  return (
    <motion.nav 
      className={`navbar ${isScrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      style={{ backgroundColor: 'white' }}
    >
      <div className="logo">
        <Link to="/">
          <motion.img 
            src={`${process.env.PUBLIC_URL}/assets/logo-lawsutra.svg`} 
            alt="Lawsutra Logo" 
            height={60} 
            width={180}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          />
        </Link>
      </div>
      <div className="nav-links">
        {navLinks.map((link) => (
          <motion.div
            key={link.to}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link 
              to={link.to}
              className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
            >
              <span className="nav-icon" style={{ marginRight: '8px' }}>{link.icon}</span>
              <span className="nav-text">{link.text}</span>
            </Link>
          </motion.div>
        ))}
        <motion.a 
          href="https://chat.lawsutra.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
          whileHover={{ 
            scale: 1.05,
            boxShadow: "0px 0px 8px rgb(255,255,255)"
          }}
          whileTap={{ scale: 0.95 }}
          style={{ color: 'white' }}
        >
          Get Started
        </motion.a>
      </div>
    </motion.nav>
  );
};

export default Navbar;
